<button
[ngClass]="buttonCSS"
(click)="onClickButton($event)"
>
    <span *ngIf="buttonIcon" [ngClass]="buttonIcon"></span>
    <span *ngIf="buttonText" [ngClass]="textCSS">{{buttonText}}</span>
</button>
